import * as Yup from 'yup';

/**
 * Validation schema for the improved signup form
 * Ensures all required fields are properly filled before submission
 */

export const ImprovedSignupFormValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters')
    .max(100, 'First name is too long')
    .matches(
      /^[a-zA-ZäöüßÄÖÜ\s'-]+$/,
      'Only letters, spaces, hyphens and apostrophes are allowed',
    ),

  lastName: Yup.string()
    .required('Last name is required')
    .min(2, 'Last name must be at least 2 characters')
    .max(100, 'Last name is too long')
    .matches(
      /^[a-zA-ZäöüßÄÖÜ\s'-]+$/,
      'Only letters, spaces, hyphens and apostrophes are allowed',
    ),

  email: Yup.string()
    .required('Email is required')
    .email('Please enter a valid email address')
    .max(255, 'Email is too long'),

  phone: Yup.string()
    .optional()
    .matches(
      /^\+?[1-9]\d{1,14}$/,
      'Please enter a valid phone number (international format)',
    ),

  institution: Yup.string()
    .required('Institution is required')
    .min(3, 'Institution name must be at least 3 characters')
    .max(200, 'Institution name is too long'),

  institutionAddress: Yup.string().optional().max(300, 'Address is too long'),

  academicDegree: Yup.string().required('Academic degree is required'),

  fieldOfStudy: Yup.string().required('Field of study is required'),

  position: Yup.string().required('Position is required'),

  orcidId: Yup.string()
    .optional()
    .matches(
      /^(\d{4}-\d{4}-\d{4}-\d{3}[0-9X])?$/,
      'ORCID format: 0000-0000-0000-0000',
    ),
});
